const initialState = {
  config: null,
  loading: false,
  saving: false,
  saved: false,
  error: null
};

const outboundFollowUpsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'OUTBOUND_FOLLOW_UP/LOADING':
      return { ...state, loading: true, error: null };
    case 'OUTBOUND_FOLLOW_UP/LOADED':
      return { ...state, loading: false, config: action.data };
    case 'OUTBOUND_FOLLOW_UP/FETCH_ERROR':
      return { ...state, loading: false, error: action.payload || 'Error cargando configuración' };
    case 'OUTBOUND_FOLLOW_UP/SAVING':
      return { ...state, saving: true, saved: false, error: null };
    case 'OUTBOUND_FOLLOW_UP/SAVED':
      return { ...state, saving: false, saved: true, config: action.data };
    case 'OUTBOUND_FOLLOW_UP/SAVE_ERROR':
      return { ...state, saving: false, error: action.payload || 'Error guardando configuración' };
    case 'OUTBOUND_FOLLOW_UP/RESET_SAVED':
      return { ...state, saved: false };
    default:
      return state;
  }
};

export default outboundFollowUpsReducer;
